import { createSelector } from '@reduxjs/toolkit'

import { RootState } from '../configure_store'

const _getState = (state: RootState) => state.support

export const getAboutMembership = createSelector(
  _getState,
  state => state.aboutMembership
)

export const getAboutNH = createSelector(_getState, state => state.aboutNH)

export const getWhatToDos = createSelector(_getState, state => state.whatToDos)

export const getWhatToDoItemById = (id: number) =>
  createSelector(_getState, state =>
    state.whatToDos?.find(whatToDo => whatToDo.id === id)
  )

export const getFlashNews = createSelector(_getState, state => state.flashNews)
